/**
 * Truncate text from the start
 */
export const truncateStart = (text, max = 15) => {
  if (!text || typeof text !== "string") return "";
  if (text.length <= max) return text;

  return "…" + text.slice(-(max - 1));
};

/**
 * Truncate text from the end
 */
export const truncateEnd = (text, max = 15) => {
    if (!text || typeof text !== "string") return "";
    if (text.length <= max) return text;
  
    return text.slice(0, max) + "…";
  };
  
  
  /**
   * Truncate text from middle
   */
  export const truncateMiddle = (text, max = 15) => {
    if (!text || typeof text !== "string") return "";
    if (text.length <= max) return text;
  
    const half = Math.floor((max - 1) / 2);
  
    return text.slice(0, half) + "…" + text.slice(-half);
  };
  
  
  /**
   * Truncate path but preserve extension
   * Example:
   * /home/user/projects/image.png
   * → /home/us…png
   */
  export const truncatePathWithExt = (filename, max = 18) => {
    if (!filename || typeof filename !== "string") return "";
    if (filename.length <= max) return filename;
  
    const lastDot = filename.lastIndexOf(".");
    if (lastDot === -1) {
      return filename.slice(0, max - 1) + "…";
    }
  
    const ext = filename.slice(lastDot); // ".jpg"
    const base = filename.slice(0, lastDot);
  
    const allowedBaseLength = max - ext.length - 1; // -1 for ellipsis
  
    if (allowedBaseLength <= 0) {
      return "…" + ext;
    }
  
    return base.slice(0, allowedBaseLength) + "…" + ext;
  };
  
  
  /**
   * Smart truncate dispatcher
   * mode:
   *  - "end"
   *  - "middle"
   *  - "path"
   */
  export const truncateText = (text, max = 15, mode = "end") => {
    const validModes = ["start", "end", "middle", "path"];
  
    if (!validModes.includes(mode)) {
      console.warn("Invalid truncate mode:", mode);
      return truncateEnd(text, max);
    }
  
    switch (mode) {
      case "start":
        return truncateStart(text, max);
  
      case "middle":
        return truncateMiddle(text, max);
  
      case "path":
        return truncatePathWithExt(text, max);
  
      default:
        return truncateEnd(text, max);
    }
  };